// Loading Window Object
export const setPageSettingsData = (pageSettingsData) => {

  let settings = pageSettingsData.settings;

  window.settings = settings;
  window.injectedConfiguratorSettings = pageSettingsData.settings;
  window.productMetas = pageSettingsData.meta;
  window.breadcrumbInfo = pageSettingsData.thdBreadcrumbInfo.thdBreadcrumbs;
  window.featureGates = pageSettingsData.featureGates;
  document.title = pageSettingsData.meta.title;
};

export default setPageSettingsData;
